export default "__VITE_ASSET__504cbcc7__"